import React from 'react';
import { components } from 'react-select';
import { LabeledElement } from 'components/form-elements/labels/LabeledElement';
import { Select } from 'components/form-elements/selects/Select';

const Option = (props) => {
  const { isSelected, label } = props;
  
  return (
    <div>
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={isSelected}
          onChange={() => null}
        />{' '}
        <label>{label}</label>
      </components.Option>
    </div>
  );
};

const MultiValueRemove = (props) => (props?.selectProps.isClearable ? <components.MultiValueRemove {...props} /> : null);

export const MultiSelect = ({
  options, title, description,
  isDisabled,
  className, onChange, value, placeholder, isLoading, isClearable, isSearchable, components }) => (
    <LabeledElement
      label={title}
      description={description}
    >
      <Select
        options={options}
        isMulti
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        isDisabled={isDisabled}
        isSearchable={isSearchable}
        components={{
          Option,
          MultiValueRemove,
          ...components,
        }}
        onChange={onChange}
        allowSelectAll
        value={value}
        className={className}
        placeholder={placeholder}
        isLoading={isLoading}
        isClearable={isClearable}
      />
    </LabeledElement>
);

